import React from 'react';

import { Skademeldingstype } from '../../../types/generated-types';
import { getExternalUrlForSkadetype } from '../../deep-link-handler';
import { eikaForsikringPhonenumber, LinkButton, phone } from '../utils';

export default (
    <div>
        <p>Har du eller noen i din familie vært utsatt for personskade, kan du melde inn skaden din her.</p>
        <p>Ønsker du veiledning kan du kontakte oss på telefon: {phone(eikaForsikringPhonenumber)}</p>
        <LinkButton href={getExternalUrlForSkadetype(Skademeldingstype.PersonskadeUlykke)}>Meld skade</LinkButton>
    </div>
);
